import {
  Component,
  OnInit,
  Input,
  TemplateRef,
  ViewChild,
  Output,
  EventEmitter,
} from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ImporterService } from 'src/app/core/services/importer.service';
import { VehicleService } from 'src/app/core/services/vehicle.service';
import {
  colorType,
  bodyType,
  fuelType,
} from 'src/app/core/const/carConfigurator';
import { NgForm } from '@angular/forms';

@Component({
  selector: 'app-car-configurator-import',
  templateUrl: './car-configurator-import.component.html',
  styleUrls: ['./car-configurator-import.component.css'],
})
export class CarConfiguratorImportComponent implements OnInit {
  @ViewChild('carConfigModal')
  public carConfigModal: TemplateRef<any>;
  private modalCarConfig: NgbModalRef;

  @Input() userId: any;
  @Input() vehicleId: any;
  @Input() vehicle: any;
  @Input() carConfImporter: any;
  @Input() vinDecodeEnabled: boolean;
  @Output() isImportingChanged = new EventEmitter<boolean>();
  @Output() openConfirmRequest = new EventEmitter<boolean>();

  carConfigVehicles: any;
  carConfigPage = 1;
  carConfigLimit = 8;
  carConfigData: any = {};
  isLoading: boolean = false;
  selectedVehicleId: string | null = null;

  importerInfoPopup: boolean = false;
  isImportedInfo: boolean = false;
  isImporting: boolean = false;

  availableModels: string[] = [];
  isModalOpen: boolean = false;

  isVinDecoded: boolean = false;
  isRegex: boolean = false;
  selectedMake: any;
  selectedModel: any;

  carConfigFields = [
    {
      label: 'vehicles.imports.make',
      placeholder: 'vehicles.imports.make',
      name: 'make',
      type: 'selectWithSearch',
      error: '',
    },
    {
      label: 'vehicles.imports.model',
      placeholder: 'vehicles.imports.model',
      name: 'model',
      type: 'selectWithSearch',
      error: '',
    },
    {
      label: 'vehicles.imports.year',
      placeholder: 'vehicles.imports.year',
      name: 'modelYear',
      type: 'text',
      error: '',
    },
    {
      label: 'vehicles.imports.bodyType',
      placeholder: 'vehicles.imports.selectBodyType',
      name: 'bodyType',
      type: 'select',
      options: bodyType,
    },
    {
      label: 'vehicles.imports.color',
      placeholder: 'vehicles.imports.selectColor',
      name: 'color',
      type: 'select',
      options: colorType,
    },
    {
      label: 'vehicles.imports.fuelType',
      placeholder: 'vehicles.imports.selectFuelType',
      name: 'fuelType',
      type: 'select',
      options: fuelType,
    },
    {
      label: 'vehicles.imports.horsePower',
      placeholder: 'vehicles.imports.horsePower',
      name: 'horsePower',
      type: 'text',
    },
    {
      label: 'vehicles.imports.engineSize',
      placeholder: 'vehicles.imports.engineSize',
      name: 'engineSize',
      type: 'text',
    },
    {
      label: 'vehicles.imports.vin',
      placeholder: 'vehicles.imports.vin',
      name: 'vin',
      type: 'text',
    },
  ];

  requestImagesText: string;

  constructor(
    private modalService: NgbModal,
    public router: Router,
    private importerService: ImporterService,
    private vehicleService: VehicleService
  ) {}

  ngOnInit(): void {}

  open(): Promise<boolean> {
    return new Promise<boolean>((resolve) => {
      this.modalCarConfig = this.modalService.open(this.carConfigModal, {
        size: 'lg',
        backdrop: 'static',
      });
      this.isModalOpen = true;

      if (this.carConfImporter?.importerId && this.vehicle) {
        this.loadVehicles();
        this.loadMakes();
        this.requestImagesText = `Send request to get images for vehicle ${this.vehicle?.vehicleInfo?.vin}`;
      }
      this.modalCarConfig.result.then(resolve, resolve);
    });
  }

  async close(): Promise<void> {
    this.modalCarConfig.close();
  }

  closeModal(): void {
    this.modalService.dismissAll();
  }

  resetLoadingState(): void {
    this.isLoading = false;
    this.isVinDecoded = false;
    this.selectedMake = null;
  }

  loadVehicles(): void {
    this.isLoading = true;
    const requestData = {
      ...this.carConfigData,
      vinRecognition: true,
      vin: this.vehicle?.vehicleInfo?.vin || '',
      // vehicleId: this.vehicleId
    };
    this.selectedMake = null;
    this.selectedModel = null;

    this.importerService
      .importVehicles(
        this.userId,
        this.carConfImporter?.importerId,
        this.carConfigPage,
        this.carConfigLimit,
        requestData
      )
      .subscribe(
        (response) => {
          this.carConfigVehicles = response;

          if (!response.results.length) {
            this.retryLoadVehicles();
            this.isVinDecoded = false;
          } else {
            this.isVinDecoded = this.vinDecodeEnabled;
            // if (!this.vinDecodeEnabled)
            // this.onMakeChange(response.results[0].vehicleMake);
            this.onMakeChange(response.results[0].vehicleMake);
            this.isLoading = false;
            this.isRegex = true;
          }
        },
        (error) => {
          console.error('Error Importing Vehicle:', error);
          this.retryLoadVehicles();
        }
      );
  }

  retryLoadVehicles(): void {
    this.importerService
      .importVehicles(
        this.userId,
        this.carConfImporter?.importerId,
        this.carConfigPage,
        this.carConfigLimit
      )
      .subscribe(
        (response) => {
          this.carConfigVehicles = response;
          this.isLoading = false;
          this.isVinDecoded = false;
        },
        (error) => {
          console.error('Error Importing Vehicle:', error);
          this.resetLoadingState();
        }
      );
  }

  loadMakes(): void {
    this.isLoading = true;
    this.importerService
      .importMake(this.userId, this.carConfImporter?.importerId)
      .subscribe(
        (response) => {
          this.carConfigFields[0].options = response;
          this.isLoading = false;
        },
        (error) => {
          console.error('Error Importing Vehicle:', error);
        }
      );
  }

  loadModelsByMake(makeId: string): void {
    this.isLoading = true;
    this.importerService
      .importModelsByMake(this.userId, this.carConfImporter?.importerId, makeId)
      .subscribe(
        (response) => {
          this.carConfigFields[1].options = response;
          this.isLoading = false;
        },
        (error) => {
          console.error('Error Importing Vehicle:', error);
        }
      );
  }

  prepareRequestData(formData: any): any {
    const requestData = {
      ...formData,
      vinRecognition: this.isRegex ? true : undefined,
    };

    if (this.isRegex) {
      requestData.vin = this.vehicle?.vehicleInfo?.vin;
    }

    if (this.selectedMake) requestData.make = this.selectedMake.name;
    if (this.selectedModel) requestData.model = this.selectedModel.name;

    return requestData;
  }

  importCarConfigVehicles(requestData: any): void {
    this.isLoading = true;

    this.importerService
      .importVehicles(
        this.userId,
        this.carConfImporter?.importerId,
        this.carConfigPage,
        this.carConfigLimit,
        requestData
      )
      .subscribe(
        (response) => {
          this.carConfigVehicles = response;
          this.isLoading = false;
        },
        (error) => {
          console.error('Error Importing Vehicle:', error);
          this.isLoading = false;
        }
      );
  }

  changeCarConfigPerPage(event: number): void {
    this.carConfigPage = event;
    const requestData = this.prepareRequestData(this.carConfigData);
    this.importCarConfigVehicles(requestData);
  }

  searchVehicles(formData: any): void {
    const requestData = this.prepareRequestData(formData);
    this.importCarConfigVehicles(requestData);
  }

  selectVehicle(vehicle: any): void {
    if (this.selectedVehicleId === vehicle.id) {
      this.selectedVehicleId = null;
    } else {
      this.selectedVehicleId = vehicle.id;
    }
  }

  onMakeChange(selectedMake: any): void {
    this.carConfigData['model'] = '';
    if (selectedMake) {
      this.loadModelsByMake(selectedMake.id);
      this.selectedMake = selectedMake;
    } else {
      this.carConfigFields[1].options = [];
      this.selectedMake = null;
    }
  }

  onModelChange(selectedModel: any): void {
    this.selectedModel = selectedModel || null;
  }

  importImages() {
    let body = {
      vehicleRemoteId: this.selectedVehicleId,
    };

    this.closeModal();
    this.vehicleService
      .importImages(
        this.userId,
        this.carConfImporter.importerId,
        this.vehicleId,
        body
      )
      .subscribe((res) => {
        this.isImporting = true;
        this.isImportingChanged.emit(true);
      });
  }

  @ViewChild('carConfigForm') carConfigForm: NgForm;
  errorMessage: string;

  requestImages() {
    const profileId = this.vehicle.vehicleInfo.profileId || undefined;

    let isValid = true; // Flag to check if form is valid
    this.errorMessage = ''; // Reset general error message

    // Check for missing fields and set errors
    if (this.selectedMake === null) {
      this.carConfigFields[0].error = 'vehicles.imports.validations.makeRequired'; // Add error to make field
      isValid = false;
    } else {
      this.carConfigFields[0].error = ''; // Clear error if filled
    }

    if (this.selectedModel === null) {
      this.carConfigFields[1].error = 'vehicles.imports.validations.modelRequired'; // Add error to model field
      isValid = false;
    } else {
      this.carConfigFields[1].error = ''; // Clear error if filled
    }

    if (
      this.carConfigData['modelYear'] === '' ||
      !this.carConfigData['modelYear']
    ) {
      this.carConfigFields[2].error = 'vehicles.imports.validations.yearRequired'; // Add error to year field
      isValid = false;
    } else {
      this.carConfigFields[2].error = ''; // Clear error if filled
    }

    if (this.carConfigData['color'] === '' || !this.carConfigData['color']) {
      this.carConfigFields[4].error = 'vehicles.imports.validations.colorRequired'; // Add error to year field
      isValid = false;
    } else {
      this.carConfigFields[4].error = ''; // Clear error if filled
    }

    // If any field is invalid, show a general error message
    if (!isValid) {
      this.errorMessage =
        'vehicles.imports.validations.errorMessage';
      return; // Exit if any required field is missing
    }

    let body = {};

    if (this.selectedMake?.name) {
      body['make'] = this.selectedMake.name;
    }
    if (this.selectedModel?.name) {
      body['model'] = this.selectedModel.name;
    }
    if (this.carConfigData['modelYear']) {
      body['modelYear'] = this.carConfigData['modelYear'];
    }
    if (this.carConfigData['bodyType']) {
      body['bodyType'] = this.carConfigData['bodyType'];
    }
    if (this.carConfigData['color']) {
      body['color'] = this.carConfigData['color'];
    }
    if (this.carConfigData['fuelType']) {
      body['fuelType'] = this.carConfigData['fuelType'];
    }
    if (this.carConfigData['horsePower']) {
      body['horsePower'] = this.carConfigData['horsePower'];
    }
    if (this.carConfigData['engineSize']) {
      body['engineSize'] = this.carConfigData['engineSize'];
    }
    if (this.vehicle?.vehicleInfo?.vin || this.carConfigData['vin']) {
      body['vin'] = this.vehicle?.vehicleInfo?.vin || this.carConfigData['vin'];
    }

    this.importerService
      .requestImportImages(
        this.userId,
        this.carConfImporter.importerId,
        this.vehicleId,
        body,
        profileId
      )
      .subscribe((res) => {
        this.openConfirmRequest.emit(true);
        this.closeModal();
      });
  }
}
